export default "__VITE_ASSET__CvX5l9Fk__"